import { useEffect, useState } from "react";

import styles from "./styles/Dashboard.module.scss";

import { Col, Row } from "react-bootstrap";
import { SubTitle } from "../../Components/CustomComponents";
// import MatchCard from '../../Components/Cards/MatchCard';
// import TournamentCard from '../../Components/Cards/TournamentCard';
import { BiSolidBadgeDollar } from "react-icons/bi";
import { FaDollarSign, FaUserNurse } from "react-icons/fa6";
import { GiGamepadCross } from "react-icons/gi";
import { IoIosTrendingUp, IoLogoGameControllerB } from "react-icons/io";
import DashboardCard from "../../Components/Cards/DashboardCard";
import ThemeChart from "../../Components/ThemeChart";
import { chartData, chartOptions, chartOptionsOrder } from "../../constants";
import { useGetDashboardDetailsQuery } from "../../Data/services/dashboardApi";
import { ROUTES } from "./constants";
import { FiUsers } from "react-icons/fi";
import UrgentUpdates from "./Components/UrgentUpdateCard";
import RecentActivity from "./Components/RecentActivityCard";
import QuickActions from "./Components/QuickActions";

export default function Dashboard({ setPage }) {
  let bg1 = "#fff";
  let bg2 = "#fff";
  let iconColor = "grey";

  // const {
  //   data: dashboardData,
  //   isSuccess,
  //   isLoading,
  //   isFetching,
  //   refetch,
  // } = useGetDashboardDetailsQuery();
  // console.log(dashboardData);

  /**
   * DUMMY DATA START
   */

  const dashboardData = {
    data: {
      dashboardStats: {
        active_users: 2847,
        active_agents: 2847,
        revenue: 89234,
        agent_performance: 94.2,
      },
      dashboardGraphData: {
        monthlyEarnings: [
          { month: "2025-01", total_earnings: 1000 },
          { month: "2025-02", total_earnings: 1200 },
          { month: "2025-03", total_earnings: 800 },
          { month: "2025-04", total_earnings: 2000 },
        ],
      },
    },
  };

  // const isLoading = false;
  // const isFetching = false;

  const [dummyFetch, setDummyFetch] = useState({
    isLoading: true,
    isFetching: true,
  });

  useEffect(() => {
    setTimeout(() => {
      setDummyFetch((prev) => {
        return {
          ...prev,
          isLoading: false,
          isFetching: false,
        };
      });
    }, 2000);
  }, []);

  /**
   * DUMMY DATA END
   */

  const [updatedData, setUpdatedData] = useState([]);
  const [updatedOrderData, setUpdatedOrderData] = useState([]);

  const getMonthName = (monthString) => {
    const [year, month] = monthString.split("-").map(Number); // Extract year and month
    const date = new Date(year, month - 1); // Correctly set year and 0-indexed month
    return date.toLocaleString("default", { month: "short" }); // Get short month name
  };
  // MARK: Dummy Data

  useEffect(() => {
    const updatedData = [];
    chartData.labels.forEach((month) => {
      const dataForMonth =
        dashboardData?.data?.dashboardGraphData?.monthlyEarnings?.find(
          (item) => getMonthName(item.month) === month
        );
      updatedData.push(dataForMonth ? dataForMonth.total_earnings : 0);
    });
    setUpdatedData(updatedData);
  }, [chartData.labels, dashboardData]);

  // useEffect(() => {
  //   const updatedData = [];
  //   chartData.labels.forEach((month) => {
  //     const dataForMonth =
  //       dashboardData?.data?.dashboardGraphData?.totalOrderGraph?.find(
  //         (item) => getMonthName(item.month) === month
  //       );
  //     updatedData.push(dataForMonth ? dataForMonth.total_orders : 0);
  //   });
  //   setUpdatedOrderData(updatedData);
  // }, [chartData.labels, dashboardData]);

  const handleViewLiveMatches = () => {
    setPage(ROUTES.LIVE_MATCHES);
  };

  const handleViewTournament = () => {
    setPage(ROUTES.TOURNAMENTS);
  };

  const cardData = [
    {
      icon: <FiUsers color={iconColor} />,
      number:
        dashboardData?.data == null
          ? 0
          : dashboardData?.data?.dashboardStats?.active_users,
      text: "Active Users",
      lg: 3,
    },
    {
      icon: <FiUsers color={iconColor} />,
      number:
        dashboardData?.data == null
          ? 0
          : dashboardData?.data?.dashboardStats?.active_agents,
      text: "Active Agents",
      lg: 3,
    },
    {
      icon: <FaDollarSign color={iconColor} size="20px" />,
      before_number: "$",
      number:
        dashboardData?.data == null
          ? 0
          : dashboardData?.data?.dashboardStats?.revenue,
      text: "Revenue",
      lg: 3,
    },
    {
      icon: <IoIosTrendingUp color={iconColor} />,
      after_number: "%",
      number:
        dashboardData?.data == null
          ? 0
          : dashboardData?.data?.dashboardStats?.agent_performance,
      text: "Agent Performance",
      lg: 3,
    },
  ];

  return (
    <div className={styles.Dashboard}>
      <div className={styles.headerContainer}>
        {/* <div className={styles.titleContainer}>
          <SubTitle text={"Dashboard"} />
        </div> */}
      </div>

      <Row className={`${styles.matchRow} mt-2 mb-2`}>
        {cardData.map((card, index) => (
          <Col
            key={index}
            className="mt-2 mb-2"
            lg={card?.lg}
            md={card?.lg}
            sm={6}
          >
            <DashboardCard
              loading={dummyFetch.isLoading}
              bg1={bg1}
              bg2={bg2}
              icon={card.icon}
              number={card.number ?? 100}
              text={card.text}
              before_number={card.before_number}
              after_number={card.after_number}
            />
          </Col>
        ))}
      </Row>

      <Row>
        <Col md="6" sm="12">
          <UrgentUpdates />
        </Col>
        <Col md="6" sm="12">
          <RecentActivity />
        </Col>
      </Row>

      <div className="mt-3">
        <QuickActions />
      </div>

      <Row>
        {/* <Col md={12}>
          <div className={"themeChart"}>
            <ThemeChart
              type="line"
              data={updatedData}
              chartOptions={chartOptions}
              loading={isLoading}
            />
          </div>
        </Col> */}
        {/* <Col md={6} sm={12}>
         <div className={"themeChart"}>
            <ThemeChart
              type="line"
              data={updatedOrderData}
              chartOptions={chartOptionsOrder}
              loading={isLoading}
            />
          </div> 
        </Col> */}
      </Row>
    </div>
  );
}
